
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexgw2ikJsyhcMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93pvGVZEAWcBMeta } from "/usr/src/app/pages/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "slug___af",
    path: "/af/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___am",
    path: "/am/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ar",
    path: "/ar/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___az",
    path: "/az/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___be",
    path: "/be/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___bg",
    path: "/bg/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___bn",
    path: "/bn/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___bs",
    path: "/bs/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ca",
    path: "/ca/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___cs",
    path: "/cs/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___cy",
    path: "/cy/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___da",
    path: "/da/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___dz",
    path: "/dz/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___el",
    path: "/el/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___eo",
    path: "/eo/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___et",
    path: "/et/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___eu",
    path: "/eu/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fa",
    path: "/fa/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fi",
    path: "/fi/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___tl",
    path: "/tl/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fy",
    path: "/fy/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ga",
    path: "/ga/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___gd",
    path: "/gd/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___gl",
    path: "/gl/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___gu",
    path: "/gu/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___he",
    path: "/he/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___hi",
    path: "/hi/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___hr",
    path: "/hr/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ht",
    path: "/ht/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___hu",
    path: "/hu/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___hy",
    path: "/hy/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___id",
    path: "/id/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___is",
    path: "/is/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___jv",
    path: "/jv/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ka",
    path: "/ka/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___kk",
    path: "/kk/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___km",
    path: "/km/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___kn",
    path: "/kn/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ko",
    path: "/ko/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ku",
    path: "/ku/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ky",
    path: "/ky/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___lo",
    path: "/lo/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___lt",
    path: "/lt/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___lv",
    path: "/lv/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___mg",
    path: "/mg/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___mk",
    path: "/mk/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ml",
    path: "/ml/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___mn",
    path: "/mn/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___mr",
    path: "/mr/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ms",
    path: "/ms/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___my",
    path: "/my/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ne",
    path: "/ne/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___oc",
    path: "/oc/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___pa",
    path: "/pa/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___pl",
    path: "/pl/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ro",
    path: "/ro/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ru",
    path: "/ru/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___si",
    path: "/si/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sk",
    path: "/sk/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sl",
    path: "/sl/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sq",
    path: "/sq/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sr",
    path: "/sr/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___sv",
    path: "/sv/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ta",
    path: "/ta/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___te",
    path: "/te/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___th",
    path: "/th/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___tr",
    path: "/tr/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ug",
    path: "/ug/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___ur",
    path: "/ur/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___vi",
    path: "/vi/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___zh",
    path: "/zh/:slug(.*)*",
    meta: _91_46_46_46slug_93pvGVZEAWcBMeta || {},
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "index___af",
    path: "/af",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___am",
    path: "/am",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___az",
    path: "/az",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___be",
    path: "/be",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___bn",
    path: "/bn",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___bs",
    path: "/bs",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ca",
    path: "/ca",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___cy",
    path: "/cy",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___da",
    path: "/da",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___dz",
    path: "/dz",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___el",
    path: "/el",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___eo",
    path: "/eo",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___et",
    path: "/et",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___eu",
    path: "/eu",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___fa",
    path: "/fa",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___fi",
    path: "/fi",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___tl",
    path: "/tl",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___fy",
    path: "/fy",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ga",
    path: "/ga",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___gd",
    path: "/gd",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___gl",
    path: "/gl",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___gu",
    path: "/gu",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___he",
    path: "/he",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___hr",
    path: "/hr",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ht",
    path: "/ht",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___hu",
    path: "/hu",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___hy",
    path: "/hy",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___is",
    path: "/is",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___jv",
    path: "/jv",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ka",
    path: "/ka",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___kk",
    path: "/kk",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___km",
    path: "/km",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___kn",
    path: "/kn",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ku",
    path: "/ku",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ky",
    path: "/ky",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___lo",
    path: "/lo",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___lt",
    path: "/lt",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___lv",
    path: "/lv",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___mg",
    path: "/mg",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___mk",
    path: "/mk",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ml",
    path: "/ml",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___mn",
    path: "/mn",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___mr",
    path: "/mr",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ms",
    path: "/ms",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___my",
    path: "/my",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ne",
    path: "/ne",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___oc",
    path: "/oc",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___pa",
    path: "/pa",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___si",
    path: "/si",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___sk",
    path: "/sk",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___sl",
    path: "/sl",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___sq",
    path: "/sq",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___sr",
    path: "/sr",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ta",
    path: "/ta",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___te",
    path: "/te",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ug",
    path: "/ug",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ur",
    path: "/ur",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/usr/src/app/pages/index.vue")
  }
]